// /privacy-choices (giftsprofile.com/privacy-choices comes here too): the "Your privacy choices"
// panel on a page of its own, for the privacy policy to link to (Edward, Oct 26). The same choice as
// the footer link and the site's panel (components/ConsentBanner.tsx).

import { ConsentPanel, useConsent } from "../components/ConsentBanner";
import { Page } from "../components/Page";

export function PrivacyChoicesPage() {
  const [state, choose] = useConsent();
  return (
    <Page>
      <h1 className="heading mt-10 text-[30px] leading-[1.1]">Your privacy choices</h1>
      <p className="mt-3 max-w-[60ch] text-[16px] leading-relaxed text-muted">
        Choose whether Gifts Profile uses cookies and similar tools from advertising partners, on giftsprofile.com and in the test. Your choice is kept in this browser.
      </p>
      <div className="mt-6">
        {state ? (
          <ConsentPanel state={state} choose={choose} showStatus />
        ) : (
          <p role="status" className="text-muted">
            One moment…
          </p>
        )}
      </div>
      <p className="mt-6 text-[13px] text-muted">
        Where you are, for these rules, comes from your IP address, looked up on our own server:{" "}
        <a href="https://db-ip.com" target="_blank" rel="noopener noreferrer">
          IP Geolocation by DB-IP
        </a>
        .
      </p>
    </Page>
  );
}
